module.exports = __webpack_public_path__ + "img/44ne.4ff12c01.svg";